import store from '../index'
import Cookies from 'js-cookie'

const state = {
  // 登录状态为没登录
  logined: false,
  user: {},
  token: '', //用户token
  userAKInfo: '',//用户AK
  userCKInfo: '',//用户CK
  fullFlag: true,//全屏展示
  logOutFlag: false,//退出全屏
  commonFlag: true,//头部和底部
  pathMainFlag: false,//是否点击立即体验登录标识
  isPhoneFlag: false,//区分移动或者pc
  drawReviewNum: 'GS京(2023)0226号',
  userApiInfo:{}
}

const mutations = {
  /* 用户token*/
  setToken (state, token) {
    state.token = token;
    localStorage.setItem('token', token);  //获取到新的token的时候赋值给sessionStorag
  },
  setUser (state, user) {
    var _user = _.merge({}, state.user);
    if (!_.size(_user)) {
      _user = {};
    }
    if (_.size(user)) {
      // 先让登录状态变为登录了
      state.logined = true;
      localStorage.setItem("logined", "true");
      _.each(user, function (value, key) {
        _user[key] = value;
      })
    }
    localStorage.setItem("user", JSON.stringify(_user));
    state.user = _user;
  },
  /* 退出登录*/
  logOut (state) {
    localStorage.clear();
    sessionStorage.clear();
    state.user = {};
    state.token = null;
    state.logined = false;
    state.userAKInfo = null;
    state.userCKInfo = null;
    Cookies.remove('user', { domain: state.domain })
    Cookies.remove('user')
    //清空权限值
    store.dispatch('permission/ResetPermissions')
    state.userApiInfo = {};
  },
  // 更新登录标识
  updateLogined (state, flag) {
    state.logined = flag;
    localStorage.setItem("logined", flag);
  },
  // 用户client_id和apikey
  setUserApiInfo (state, val) {
    let data = _.merge({}, state.userApiInfo);
    if (!_.size(data)) {
      data = {};
    }
    if (_.size(val)) {
      _.each(val, function (value, key) {
        data[key] = value;
      })
    }
    localStorage.setItem("userApiInfo", JSON.stringify(data));
    state.userApiInfo = data;
  },
  // 用户AK
  setUserAK (state, val) {
    state.userAKInfo = val;
    localStorage.setItem('userAKInfo', val);
  },
  // 用户CK
  setUserCK (state, val) {
    state.userCKInfo = val;
    localStorage.setItem('userCKInfo', val);
  },
  // 全屏展示改变
  setFullFlag (state, flag) {
    state.fullFlag = flag
  },
  // 退出全屏改变
  setLogOutFlag (state, flag) {
    state.logOutFlag = flag
  },
  // 控制头部和底部
  setCommonFlag (state, flag) {
    state.commonFlag = flag
  },
  // 是否立即体验进入登录
  setPathMainFlag (state, flag) {
    state.pathMainFlag = flag
  },
  // 区分移动或者pc
  setIsPhoneFlag (state, flag) {
    state.isPhoneFlag = flag
  },
  // 更改审图号
  setDrawReviewNum (state, val) {
    state.drawReviewNum = val
  },
}

const actions = {

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js